import React, {useState,useEffect,useContext,useCallback} from 'react'

import {Popconfirm,Typography,DatePicker,Select,Radio,Divider, Spin, Avatar, Menu, Dropdown, Form, Card, Drawer, Layout, Tabs, Button, Input, Space,Row, Col} from "antd";
import InfiniteScroll from 'react-infinite-scroller';
import Highlighter from 'react-highlight-words';
import {errorN, successN} from "../../general";
import { A,navigate} from "hookrouter";
import useFetch from "use-http";
import {
    BellOutlined ,
    ProfileOutlined ,
    SolutionOutlined ,
    PhoneOutlined ,
    HomeOutlined,
    ControlOutlined ,
    DollarOutlined ,
    ContainerOutlined ,
    MinusSquareOutlined ,
    BorderOutlined ,
    RightCircleOutlined,
    SearchOutlined,
    FileExcelOutlined


} from '@ant-design/icons'

import routes from "../../router"
import Store, {Context} from "../../store"
import moment from 'moment'
import FModal from "../Bookings/modal";

import { Table } from "ant-table-extensions";
import {ShowReport} from "../Bookings/function";

const {Sider, Content,Footer } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Text } = Typography;

const formatter = new Intl.NumberFormat('en-MY', {
    //style: 'currency',
    //currency: 'MYR',
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function Folios(props) {
    const [state,dispatch] = useContext(Context)
    const { get, post, response, loading, error, del, put } = useFetch()
    const [drawOpen, setDrawOpen] = useState(false);

    const [form] = Form.useForm()
    const [formLayout, setFormLayout] = useState('vertical');
    const handleFinish = useCallback(() => {
        //console.log('Submit: ', form.getFieldsValue(true));

        const values = form.getFieldsValue(true);

    }, [form])

    const [dateRange, setDateRange] = useState(false);
    const [keyword, setKeyword] = useState(false);
    const [arrivalDate, setArrivalDate] = useState(false);
    const [arrivalDateRange, setArivalDateRange] = useState(false);

    const [data, setData] = useState([]);

    const [searchText, setsearchText]= useState( '');
    const [searchedColumn, setsearchedColumn]= useState( '');

    const [sourceFilters,setSourceFilters] = useState([]);
    const [statusFilters,setStatusFilters] = useState([]);
    const [agencyFilters,setAgencyFilters] = useState([]);
    const [nationalityFilters,setNationalityFilters] = useState([]);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [allowRemove, setAllowRemove] = useState(false);

    const labelCol = 22;
    const wrapperCol = 22;

    const [filteredData, setFilteredData] = useState([]);
    const [range, setRange] = useState('');


    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const hasSelected = selectedRowKeys.length > 0;

    async function removeDuplicates(data) {
        // let unique = data.reduce(function(a,b){
        //   if(a.indexOf(b) < 0) a.push(b);
        //   return a;
        // },[]);

        const unique = data.filter((thing, index) => {
            const _thing = JSON.stringify(thing);
            return index === data.findIndex(obj => {
              return JSON.stringify(obj) === _thing;
            });
          });

        //console.log('unique',unique)
        return unique;
      };

    let searchInput = null;
    const getColumnSearchProps = (dataIndex,caption) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={node => {
                    searchInput=node;
                }}
                placeholder={`Search ${caption}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
        record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
    onFilterDropdownVisibleChange: visible => {
        if (visible) {
            setTimeout(() => searchInput.select(), 100);
        }
    },
    render: text =>
        searchedColumn === dataIndex ? (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
});

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        /*this.setState({*/
            setsearchText(selectedKeys[0]);
            setsearchedColumn(dataIndex);
       /* });*/
    };

    const handleReset = clearFilters => {
        clearFilters();
        setsearchText('');
    };

    async function loadData() {
        form.validateFields().then(async values => {

            setSelectedRowKeys([]);

            let obj = JSON.parse(localStorage.getItem('currentproperty'));

            let s = '';
            let e = '';
            let searchstr ='';
            let parameter = '';



            if(values.typex === 'Date Range')
            {
                //s = moment(values.dtDateRange[0]).format('YYYY-MM-DD');
                s = moment.utc(values.dtDateRange[0]).subtract(1, 'days').format('YYYY-MM-DD');
                //e = moment(values.dtDateRange[1]).format('YYYY-MM-DD');
                e = moment.utc(values.dtDateRange[1]).subtract(1, 'days').format('YYYY-MM-DD');

                //s = moment(values.dtDateRange[0]).format('YYYY-MM-DD');
                //e = moment(values.dtDateRange[1]).format('YYYY-MM-DD');

                //parameter = `?cstart=${s}T00:00:00Z&cend=${e}T23:59:59Z`
                parameter = `?cstart=${s}T16:00:00Z&cend=${e}T16:00:00Z`

                //console.log('parameter', parameter)

                setRange(`From ${moment(values.dtDateRange[0]).format('DD-MM-YYYY')} to ${moment(values.dtDateRange[1]).format('DD-MM-YYYY')}`);
            }
            if(values.typex === 'Keyword')
            {
                searchstr = values.keywordSearch;

                if(values.keywordType === 'Name' )
                {
                    parameter = `?name=${searchstr}`
                }
                else if(values.keywordType === 'Folio No.' )
                {
                    parameter = `?no=${searchstr}`
                }
                else if(values.keywordType === 'Contact No.' )
                {
                    parameter = `?tel=${searchstr}`
                }

                setRange(`Search By: ${searchstr}`);
            }
            if(values.typex === 'Arrival Date')
            {
                s = moment.utc(values.dtArrivalDate).subtract(1, 'days').format('YYYY-MM-DD');
                parameter = `?start=${s}T16:00:00Z`
                //console.log('parameter', parameter)
                setRange(`By Arrival Date: ${moment(values.dtArrivalDate).format('DD-MM-YYYY')}`);
            }
            if(values.typex === 'Arrival Date Range')
            {

                s = moment.utc(values.dtArrivalDateRange[0]).subtract(1, 'days').format('YYYY-MM-DD');
                e = moment.utc(values.dtArrivalDateRange[1]).subtract(1, 'days').format('YYYY-MM-DD');

                //parameter = `?start=${s}T00:00:00Z&end=${e}T23:59:59Z`
                parameter = `?start=${s}T16:00:00Z&end=${e}T16:00:00Z`

                setRange(`By Arrival Date: From ${moment(values.dtArrivalDateRange[0]).format('DD-MM-YYYY')} to ${moment(values.dtArrivalDateRange[1]).format('DD-MM-YYYY')}`);
            }

            try
            {
                //let folioList = await get(`/api/hotels/${obj.id}/folios/payments${parameter}`)
                let folioList = await get(`/api/hotels/${obj.id}/folios/payments${parameter}`)
                if (response.ok)
                {
                    //console.log("folioList", folioList);

                    if(allowRemove === true)
                    {
                        if(state.role === 'administrator')
                        {
                            //no need filter 'Removed'
                        }
                        else
                        {
                            folioList = folioList.filter(x => x.status !== 'Removed');
                        }
                    }
                    else
                    {
                        folioList = folioList.filter(x => x.status !== 'Removed');
                    }

                    let table1 =[];
                    let table2 =[];

                    let source =[];
                    let status =[];
                    let agency =[];
                    let nationality =[];

                    for(let i of folioList)
                    {
                        //if(i.payments !== null && i.payments !== undefined)
                        // for(let x of i.payments)
                        // {
                        //     table2.push({
                        //         key: x.id,
                        //         id:x.id,
                        //         billNo:"",
                        //         name:"",
                        //         no:x.no,
                        //         date:moment(x.date).format('DD-MM-YYYY'),
                        //         status: "",
                        //         amount:x.amount,
                        //         method:x.data.method,
                        //         type:x.type,
                        //         by:x.data.by != null ? x.data.by.name : "",
                        //         bookingid:i.id
                        //     })
                        // }


                        table1.push({
                            key: i.id + ';' + i.status,
                            id:i.id,
                            date: moment(i.created).format('DD-MM-YYYY'),
                            no:i.no,
                            name:i.data.payor.name,
                            status:i.status,
                            source:i.source,
                            otaagency:i.data.payor.otaagency.name,
                            refno: i.data.rcode != undefined && i.data.rcode != null && i.data.rcode != '' ? (i.data.bcode != null && i.data.bcode != '' ? (i.data.rcode.toString().indexOf('/') == -1 ? (i.data.bcode + '/' + i.data.rcode): i.data.rcode) : i.data.rcode) : (i.data.payor.refno != null && i.data.payor.refno != '' ? i.data.payor.refno:''), //i.data.rcode, //payor.refno,
                            start:i.data.stay.arrival,
                            end:i.data.stay.departure,
                            by:i.data.by != null ? i.data.by.name : "",
                            amount:i.amount != null ? i.amount : "0.00",
                            paid:i.paid != null ? i.paid : "0.00",
                            balance: i.amount != null ? (i.amount - i.paid).toFixed(2) : "0.00",
                            tel:i.data.payor.tel,
                            email:i.data.payor.email,
                            nationality: i.data.payor.nationality.name,
                            cancelNote:i.data.cancelledBy != null ? (i.data.cancelledBy.reason != null ? i.data.cancelledBy.reason : "") : "",
                            cancelBy:i.data.cancelledBy != null ? (i.data.cancelledBy.name != null ? i.data.cancelledBy.name : "") : "",
                            folinvno:  i.invoiceno,
                            folio:i.folio

                        })

                        source.push({text:i.source,value:i.source});
                        status.push({text:i.status,value:i.status});
                        agency.push({text:i.data.payor.otaagency.name,value:i.data.payor.otaagency.name});
                        nationality.push({text:i.data.payor.nationality.name,value:i.data.payor.nationality.name});


                    }

                    let so = await removeDuplicates(source);
                    let st = await removeDuplicates(status);
                    let ag = await removeDuplicates(agency);
                    let nt= await removeDuplicates(nationality);

                    //console.log("so ans so", so)

                    setData(table1);
                    setSourceFilters(so);
                    setStatusFilters(st);
                    setAgencyFilters(ag);
                    setNationalityFilters(nt);

                    setFilteredData(table1);
                }
                else
                {
                    if(response.status === 401)
                    {
                        localStorage.removeItem('session');
                        window.location.reload();
                    }
                    else
                    {
                    errorN(`Load Data - ${response.status}: ${response.statusText}. Please contact the administrator.`);
                    }

                }
            }
            catch(err)
            {
                errorN(`Error Load Data: ${err}. Please contact the administrator.`);
            }

        })
    }

    useEffect(() => {


        if(localStorage.getItem('session') === null)
        {
            navigate('/')
        }
        else
        {
            let obj = JSON.parse(localStorage.getItem('customsetting'));

            if (obj !== null && obj !== undefined)
            {
                if (obj.data !== null && obj.data !== undefined)
                {
                    if (obj.data.deleteFolio !== null && obj.data.deleteFolio !== undefined)
                    {
                        if (obj.data.deleteFolio === true)
                        {
                            setAllowRemove(obj.data.deleteFolio);
                        }
                    }
                }
            }

            loadData();
        }

        //loadData().then(r => {});


        return () => {

        }
    },[])

    const onChange = (e) => {
        //console.log('type', e.target.value)

        form.setFieldsValue({typex: e.target.value});

        setDateRange(false);
        setKeyword(false);
        setArrivalDate(false);
        setArivalDateRange(false);

        if(e.target.value === 'Date Range')
        {
            setDateRange(true);
        }

        if(e.target.value === 'Keyword')
        {
            setKeyword(true);
        }

        if(e.target.value === 'Arrival Date')
        {
            setArrivalDate(true);
        }

        if(e.target.value === 'Arrival Date Range')
        {
            setArivalDateRange(true);
        }

    }

    const columns = [

        {
            width: '100px',
            title: '',
            dataIndex: 'action2',
            key: 'action2',
            render: (text, record) => (
                <>
                    <Space>
                        {/*{record.status !== 'Cancelled' ?
                            <FModal formname={'update'} obj={{...record, folioid: record.id}} loadData={loadData} />
                            :
                            null
                        }*/}
                        <FModal formname={'update'} obj={{...record, folioid: record.id}} loadData={loadData} />
                        {record.status === 'Open' ?
                            <FModal formname={'checkinout'} obj={{...record, folioid: record.id}} loadData={loadData} />
                            :
                            null
                        }
                    </Space>

                </>
            )
        },
        {
            width: '100px',
            title:"Date",
            dataIndex:"date",
            key:"date",
            sorter: (a, b) => a.date.localeCompare(b.date),
        },
        {
            width: '100px',
            title:"No.",
            dataIndex:"no",
            key:"no",
            sorter: (a, b) => a.no.localeCompare(b.no),
        },
        {
            width: '200px',
            title:"Name",
            dataIndex:"name",
            key:"name",
            ...getColumnSearchProps('name','Name'),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            width: '100px',
            title:"Status",
            dataIndex:"status",
            key:"status",
            filters: statusFilters,
            onFilter: (value, record) => record.status.indexOf(value) === 0,
            sorter: (a, b) => a.status.localeCompare(b.status),
        },
        {
            width: '100px',
            title:"Invoice No.",
            dataIndex:"folinvno",
            key:"folinvno",
            ...getColumnSearchProps('folinvno','Invoice No.'),
            sorter: (a, b) => a.folinvno.localeCompare(b.folinvno),
        },
        {
            width: '100px',
            title:"Source",
            dataIndex:"source",
            key:"source",
            filters: sourceFilters,
            onFilter: (value, record) => record.source.indexOf(value) === 0,
            sorter: (a, b) => a.source.localeCompare(b.source),
        },
        {
            width: '100px',
            title:"Agency",
            dataIndex:"otaagency",
            key:"otaagency",
            filters: agencyFilters,
            onFilter: (value, record) => record.otaagency.indexOf(value) === 0,
            sorter: (a, b) => a.otaagency.localeCompare(b.otaagency),
        },
        {
            width: '100px',
            title:"Ref. No.",
            dataIndex:"refno",
            key:"refno",
            sorter: (a, b) => a.refno.localeCompare(b.refno),
        },
        {
            width: '100px',
            title:"Arrival",
            dataIndex:"start",
            key:"start",
            sorter: (a, b) => a.start.localeCompare(b.start),
        },
        {
            width: '100px',
            title:"Departure",
            dataIndex:"end",
            key:"end",
            sorter: (a, b) => a.end.localeCompare(b.end),
        },
        {
            width: '200px',
            title:"By",
            dataIndex:"by",
            key:"by",
            sorter: (a, b) => a.by.localeCompare(b.by),
        },
        {
            width: '100px',
            title:"Amount",
            dataIndex:"amount",
            key:"amount",
            sorter: (a, b) => a.amount.localeCompare(b.amount),
        },
        {
            width: '100px',
            title:"Received",
            dataIndex:"paid",
            key:"paid",
            sorter: (a, b) => a.paid.localeCompare(b.paid),
        },
        {
            width: '100px',
            title:"Balance",
            dataIndex:"balance",
            key:"balance",
            sorter: (a, b) => a.balance.localeCompare(b.balance),
        },
        {
            width: '150px',
            title:"Contact No.",
            dataIndex:"tel",
            key:"tel",
            sorter: (a, b) => a.tel.localeCompare(b.tel),
        },
        {
            width: '300px',
            title:"Email",
            dataIndex:"email",
            key:"email",
            sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
            width: '100px',
            title:"Nationality",
            dataIndex:"nationality",
            key:"nationality",
            filters: nationalityFilters,
            onFilter: (value, record) => record.nationality.indexOf(value) === 0,
            sorter: (a, b) => a.nationality.localeCompare(b.nationality),
        },
        {
            width: '300px',
            title:"Cancel Reason",
            dataIndex:"cancelNote",
            key:"cancelNote",
            sorter: (a, b) => a.cancelNote.localeCompare(b.cancelNote),
        },
        {
            width: '200px',
            title:"Cancel By",
            dataIndex:"cancelBy",
            key:"cancelBy",
            sorter: (a, b) => a.cancelBy.localeCompare(b.cancelBy),
        }
    ]

    const handleTableChange = (pagination, filters, sorter) => {

        let filteredData = data.filter(item => {
            return Object.entries(filters).every(([key, values]) => {
                const itemValue = item[key] ? item[key].toLowerCase() : null;
                values = values ? values.map(val => val.toLowerCase()) : null;

                // Include the item if the criterion for the key is null or undefined
                if (values === null || values === undefined) {
                    return true;
                }

                // Check if the item's property contains any of the specified values for that property
                return values.some(filterVal => itemValue.includes(filterVal));
            });
        });

        if (sorter.field) {
            filteredData.sort((a, b) => {
                if (sorter.order === 'ascend') {
                    return a[sorter.field].localeCompare(b[sorter.field]);
                } else if (sorter.order === 'descend') {
                    return b[sorter.field].localeCompare(a[sorter.field]);
                }
                return 0;
            });
        }
        // Update the filteredData state with the filtered and sorted data
        setFilteredData([...filteredData]);
    };

    async function removeFolio(){
        let ls = [];
        for(let i of selectedRowKeys)
        {
            let a = i.split(';');

            if(a[1] === 'Closed')
            {
                ls.push(a[0]);
            }
        }

        if(ls.length > 0)
        {
            let objx = {};
            objx.status = 'Removed';
            objx.id = ls;

            let a = await post(`/api/folios/status`, objx)
            if (response.ok)
            {
                successN('Removed Successfully.');
                loadData();
            }
            else
            {
                errorN(`Remove Folio - ${response.status}: ${response.statusText}. Please contact the administrator.`);
            }
        }
        else
        {
            errorN(`Remove Folio - No valid folio available.`);
        }
    }

    async function restoreFolio(){
        let ls = [];
        for(let i of selectedRowKeys)
        {
            let a = i.split(';');

            if(a[1] === 'Removed')
            {
                ls.push(a[0]);
            }
        }

        if(ls.length > 0)
        {
            let objx = {};
            objx.status = 'Closed';
            objx.id = ls;

            let a = await post(`/api/folios/status`, objx)
            if (response.ok)
            {
                successN('Restored Successfully.');
                loadData();
            }
            else
            {
                errorN(`Restore Folio - ${response.status}: ${response.statusText}. Please contact the administrator.`);
            }
        }
        else
        {
            errorN(`Restore Folio - No valid folio available.`);
        }
    }


    return (
        <>
        <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
        &nbsp;&nbsp;<ProfileOutlined />
        &nbsp;&nbsp;Folio List
        </div>
        <Layout>

            <Spin spinning={loading}>
            <Content style={{backgroundColor: 'white'}}>
                <Form
                    layout={formLayout}
                    form={form}
                    onFinish={handleFinish}

                >
                    <div style={{backgroundColor: 'white', padding: '20px', margin: '0px 0',height:'73vh',overflow:'auto'}}>
                    <InfiniteScroll
                        pageStart={0}
                        hasMore={true || false}
                        useWindow={false}
                    >
                    <div style={{backgroundColor: 'white', paddingRight: '20px',paddingLeft: '20px', paddingTop: '20px',marginRight: '20px'}}>
                    <Form.Item
                        style={{ display: 'none' }}
                        label="typex"
                        name="typex"
                        labelCol={{ span: labelCol }}
                        wrapperCol={{ span: wrapperCol }}
                        rules={[]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="type"
                        labelCol={{ span: labelCol }}
                        wrapperCol={{ span: wrapperCol }}
                        rules={[
                            {
                                required: true,
                                message: 'Please choose a search Type',
                            },
                        ]}
                        >
                            <Radio.Group onChange={onChange}>
                                <Radio value='Date Range'>Date Range</Radio>
                                <Radio value='Keyword'>Keyword</Radio>
                                <Radio value='Arrival Date'>Arrival Date</Radio>
                                <Radio value='Arrival Date Range'>Arrival Date Range</Radio>
                            </Radio.Group>
                        </Form.Item>

                        {dateRange === true ?
                        <>
                            <Space>
                                <Form.Item
                                    label="Arrival - Departure"
                                    name="dtDateRange"
                                    rules={[{ required: true, message: 'Dates missing!' }]}
                                >
                                    <RangePicker />
                                </Form.Item>

                                <Button style={{marginTop:'7px'}} onClick={() => {loadData()}} key=""type="primary">Load</Button>
                                <ShowReport data={filteredData} name={'Folio List'} range={range} no={'2'}   />
                            </Space>
                        </>
                        : null
                        }
                        {keyword === true ?
                        <>
                            <Space>
                            <Form.Item
                                label="Type"
                                name="keywordType"
                                labelCol={{ span: labelCol }}
                                wrapperCol={{ span: wrapperCol }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Type missing!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Type"
                                    style={{width: '200px'}}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    showSearch
                                    optionFilterProp="children">
                                    <Option value='Name'>Name</Option>
                                    <Option value='Folio No.'>Folio No.</Option>
                                    <Option value='Contact No.'>Contact No.</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Search Keyword"
                                name="keywordSearch"
                                labelCol={{ span: labelCol }}
                                wrapperCol={{ span: wrapperCol }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Search keyword missing!',
                                    },
                                ]}
                            >
                                <Input placeholder="Keyword" />
                            </Form.Item>
                            <Button style={{marginTop:'7px'}} onClick={() => {loadData()}} key=""type="primary">Load</Button>
                            <ShowReport data={filteredData} name={'Folio List'} range={range} no={'2'}   />
                            </Space>
                        </>
                        : null
                        }
                        {arrivalDate === true ?
                        <>
                            <Space>
                                <Form.Item
                                    label="Start"
                                    name="dtArrivalDate"
                                    rules={[{ required: true, message: 'Dates missing!' }]}
                                >
                                    <DatePicker />
                                </Form.Item>

                                <Button style={{marginTop:'7px'}} onClick={() => {loadData()}} key=""type="primary">Load</Button>
                                <ShowReport data={filteredData} name={'Folio List'} range={range} no={'2'}   />
                            </Space>

                        </>
                        : null
                        }
                        {arrivalDateRange === true ?
                        <>
                            <Space>
                                <Form.Item
                                    label="Arrival - Departure"
                                    name="dtArrivalDateRange"
                                    rules={[{ required: true, message: 'Dates missing!' }]}
                                >
                                    <RangePicker />
                                </Form.Item>

                                <Button style={{marginTop:'7px'}} onClick={() => {loadData()}} key=""type="primary">Load</Button>
                                <ShowReport data={filteredData} name={'Folio List'} range={range} no={'2'}   />
                            </Space>

                        </>
                        : null
                        }

                        {allowRemove && hasSelected && state.role === 'administrator' ?
                            <div style={{textAlign: 'right'}}>
                                <Popconfirm
                                    title="Are you sure want to Remove this folio(s)?"
                                    onConfirm={removeFolio}
                                    //onCancel={cancel}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button type="danger" style={{marginTop:'7px'}}>Remove Folio</Button>
                                </Popconfirm>

                                &nbsp;&nbsp;&nbsp;

                                <Popconfirm
                                    title="Are you sure want to Restore this folio(s)?"
                                    onConfirm={restoreFolio}
                                    //onCancel={cancel}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button type="primary" style={{marginTop:'7px'}} >Restore Folio</Button>
                                </Popconfirm>

                            </div>
                        :
                            null
                        }

                    </div>





                    <div rowKey="id" style={{backgroundColor: 'white', paddingRight: '20px',paddingLeft: '20px',paddingBottom: '20px', marginRight: '20px'}}>

                        <Table
                            rowSelection={allowRemove && state.role === 'administrator' ? rowSelection : null}
                            onChange={handleTableChange} // Handle filtering and sorting
                            defaultExpandAllRows={true}
                            columns={columns}
                            dataSource={data}
                            exportable
                            exportableProps={{ showColumnPicker: true, fileName: "Folio-List",btnProps: {
                                    type: "primary",
                                    icon: <FileExcelOutlined />,
                                    /*children: <span>Export</span>,*/
                                } }}
                            /*searchable
                            searchableProps={{
                                // dataSource,
                                // setDataSource: setSearchDataSource,
                                inputProps: {
                                    placeholder: "Search this table...",
                                    prefix: <SearchOutlined />,
                                },
                            }}*/
                            //expandable={{expandedRowRender}}
                            bordered
                            size="small"
                            //expandRowByClick={false}
                            scroll={{ x: 1500,y: 360 }}
                            pagination={false}

                            footer={pageData => {
                                let totalAmount = 0;
                                let totalReceived = 0;
                                let totalBalance = 0;

                                pageData.forEach(({ amount, paid, balance }) => {

                                    let amt = amount.toString().replace(/[^a-zA-Z0-9 .-]/g, '');
                                    let pd = paid.toString().replace(/[^a-zA-Z0-9 .-]/g, '');
                                    let bal = balance.toString().replace(/[^a-zA-Z0-9 .-]/g, '');

                                    totalAmount += parseFloat(amt);
                                    totalReceived += parseFloat(pd);
                                    totalBalance += parseFloat(bal);
                                });

                                return (
                                  <>
                                    <Text><b>Total Amount: {formatter.format(totalAmount)}</b></Text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Text><b>Total Received: {formatter.format(totalReceived)}</b></Text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Text type="danger"><b>Total Balance: {formatter.format(totalBalance)}</b></Text>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Text type="primary"><b> {hasSelected ? `Selected ${selectedRowKeys.length} items` : ''}</b></Text>
                                  </>
                                );
                              }}

                        />
                    </div>

                    </InfiniteScroll>
                    </div>
                </Form>
            </Content>
            </Spin>
        </Layout>


        </>
    );
}

export default Folios
